<template>
    <div class="ini-comment">
        <div class="ini-comment__items">
            <div v-for="(item, index) in items">
                <ini-comment-item v-bind="item" @attachment-clicked="attachmentClicked"></ini-comment-item>
                <hr v-if="index != items.length - 1"/>
            </div>
            <ini-comment-control v-if="showCommentControl" ref="commentControl" @send-button-clicked="commentSubmited"></ini-comment-control>
        </div>
    </div>
</template>

<script>
    import IniButton from '@/components/Button'
    import IniCommentItem from '@/components/HelpDesk/Comment/CommentItem'
    import IniCommentControl from '@/components/HelpDesk/Comment/CommentControl'

    export default {
        props: {
            items: Array,
            placeholder: String,
            showCommentControl: {
                type: Boolean,
                default: true
            },
        },

        components: {
            IniButton,
            IniCommentItem,
            IniCommentControl
        },

        methods: {
            attachmentClicked(attachment) {
                this.$emit('attachment-clicked', attachment)
            },

            commentSubmited(message) {
                this.$emit('comment-submited', {'message': message, 'attachments': this.$refs.commentControl.getAttachments()});
                AppHelper.scrollAndFocusOnElement(this.$refs.commentControl.element)
            },

            clear() {
                this.$refs.commentControl.clear()
            }
        }
    }
</script><style lang="scss">@import "@/assets/scss/components/HelpDesk/Comment/_comment.scss";</style>